import { Guid } from "guid-typescript";
import { FetchInterceptor } from "src/app/helpers/Index";
import { Tenant } from "src/app/interfaces/Index";
import { Service } from "./Service";

const endpoint = "Tenant";
export const TenantService = {
	endpoint,
	createSingle: async (data: Tenant) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getFullDetails: async (id: number) => await FetchInterceptor(`${process.env.REACT_APP_SERVER_APIURL}/${endpoint}/GetFullDetails/${id}`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: Tenant) => await Service.updateSingleById(endpoint, id, data)
}